import { render, staticRenderFns } from "./ModalEditMemberPermission.vue?vue&type=template&id=cafe81ae&scoped=true&"
import script from "./ModalEditMemberPermission.vue?vue&type=script&lang=js&"
export * from "./ModalEditMemberPermission.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditMemberPermission.vue?vue&type=style&index=0&id=cafe81ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafe81ae",
  null
  
)

export default component.exports